import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SC_STATE , C_URLS , C_LOGWORDING , C_ERRWORDING } from './Constants';

const LicensePage = () => {
  const navigate = useNavigate();
  const [licenseText, setLicenseText] = useState('');

  useEffect(() => {
    fetch('/NOTICE.txt')
      .then((res) => res.text())
      .then((text) => setLicenseText(text))
      .catch((err) => {
        //console.error('ライセンスファイルの読み込みに失敗しました:', err);
        setLicenseText('ライセンス情報の読み込みに失敗しました。');
      });
  }, []);

  return (
    <div style={{ padding: '20px' }}>
      <h1>OSS License</h1>
      <pre style={{
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
        backgroundColor: '#f4f4f4',
        padding: '1em',
        borderRadius: '5px',
        fontFamily: 'monospace'
      }}>
        {licenseText}
      </pre>

      {/* 元のスタイルの戻るボタン */}
      <button
        onClick={() => navigate(-1)}
        style={{
          position: 'fixed',
          bottom: '0px',
          right: '0px',
          padding: '5px 35px',
          fontSize: '12px',
          fontWeight: 'bold',
          backgroundColor: '#003399',
          color: 'white',
          borderTopLeftRadius: '15px',
          border: '3px solid #003399',
          borderBottom: '0px',
          borderRight: '0px',
          zIndex: 9999,
          lineHeight: '1.5',
          boxSizing: 'border-box',
        }}
      >
        ← Back
      </button>
    </div>
  );
};

export default LicensePage;
